<div class="form-wrapper" [class.disabled]="control.disabled" [class.error]="showValidation && control?.errors">
  @if (label) {
    <ion-label class="ion-text-start sc-ion-label-ios-h sc-ion-label-ios-s ios hydrated">{{ label }}</ion-label>
  }
  <div class="form-input">
    <!-- 
      Using one-way binding [value] instead of two-way binding [formControl] to prevent bypassing our
      custom formatting logic in onInputChange, and thus preventing emitting the mask as a value to the form.
      (preventing triggering valueChanges when the user just focuses or blurs the input without changing the value)
    -->
    <ion-input
      [value]="control?.value"
      [disabled]="control.disabled"
      inputmode="numeric"
      [clearInput]="showClearButton"
      [maskito]="maskitoOptions"
      [maskitoElement]="maskitoPredicate"
      [placeholder]="placeholder"
      [attr.data-test-id]="'time-input-component.input.ion-input'"
      (ionInput)="onInputChange($any($event.target).value)" />

    @if (icon) {
      <c-icon [icon]="icon" />
    }
  </div>

   @if (showValidation && control?.errors) {
    <div class="error-wrapper">
      <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value" />
    </div>
  }
</div>
